/*
 * Ryan O'Dowd
 * 2025-10-18
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = () => {
  return {
  };
};

export default getStyles;
